module.exports = __webpack_public_path__ + "assets/img/Guide01.eb6c3ad2.png";